import DayGridScenario from '../schema/DayGridScenario';
import { getSelectedDateRange } from '../selectors/dayGridSelectors';
import { CalendarEvent } from 'owa-calendar-types';
import { ClientItemId } from 'owa-client-ids';
import { DateRange } from 'owa-datetime-utils';

/**
 * OwaCalendarSurfaceEventHandlers (packages\calendar\packages\calendar-module\view\owa-calendar-module-view\lib\configs\OwaCalendarSurfaceEventHandlers.ts)
 * are bound to the CalendarEvent being clicked. This extra layer removes the nuances of dealing with the bound functions
 */
export default function SurfaceEventHandlerAdapter(
    scenario: DayGridScenario,
    handler: (
        scenario: DayGridScenario,
        id: ClientItemId,
        parentFolderId: string,
        event: any,
        getDateRangeToUpdate: () => DateRange
    ) => void
) {
    if (!handler) {
        return () => null;
    }

    return function(this: CalendarEvent, evt: any) {
        handler(scenario, this.ItemId, this.ParentFolderId.Id, evt, () =>
            getSelectedDateRange(scenario)
        );
    };
}
